<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
    (onRowSelect)="onRowSelect($event)">
    <ng-template pTemplate="caption">
        {{title}}
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" scope="col" [ngStyle]="{'width': col.width ,'display': col.display}"
                [pSortableColumn]="col.field==isBA || col.field==isLab || col.field == isSalesItemType? col.sort:col.field">
                {{col.header}}
                <p-sortIcon
                    [field]="col.field==isBA || col.field==isLab || col.field == isSalesItemType? col.sort:col.field">
                </p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <ng-container *ngFor="let col of columns">

                <td *ngIf="col.field!=isActive && col.field != isDefault && col.field != isPremixed &&
                    col.field!='printEnabled' && col.field!='defaultPrinter' && col.field!=isBA && col.field!=isLab &&
                    masterListType != machineType && col.field!=isSalesItemType && col.field != isProcessStepMachineType &&
                    col.field != isProcessStepPrinter  && col.field != isProductType && col.field != isBuffer && col.field != isSequencer &&
                    col.field!=isDefaultTemplate && col.field != isLiquidHandling && col.field != isMeasurements &&
                    col.field != isScanner && col.field != isFlaTestProcess && col.field != isUnboxingInBatches && col.field != haveClippingMachine && col.field != isReducedConfirmationTests && col.field != isReportingOutsideBB && col.field != batchIDRegex && col.field != isNumberOfPositivePCRControls && col.field != isNumberOfNegativePCRControls" class="wrapword">
                    {{rowData[col.field]}}
                </td>
                <td *ngIf="masterListType == machineType && col.field!=isMachineType && col.field!=isLab && col.field!=isActive &&
                    col.field != isLiquidHandling && col.field != isMeasurements && col.field != isScanner && col.field != isSequencer">
                    {{rowData[col.field]}}
                </td>
                <td *ngIf="col.field==isMachineType && masterListType == machineType">
                    {{rowData[col.field]!= null? rowData[col.field].name :''}}
                </td>
                <td *ngIf="col.field == isActive || col.field== isDefault || col.field == isPremixed ||
                    col.field == isLiquidHandling || col.field == isMeasurements || col.field == isScanner || col.field == isSequencer">
                    <p-checkbox id="active" disabled="true" [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
                </td>
                <td *ngIf="col.field == 'printEnabled'">
                    <p-checkbox id="printEnabled" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
                </td>
                <td *ngIf="col.field == 'defaultPrinter'">
                    <p-checkbox id="defaultPrinter" disabled [(ngModel)]="rowData[col.field]" binary="true">
                    </p-checkbox>
                </td>
                <td *ngIf="col.field == isBA || col.field==isLab || col.field == isProcessStepMachineType || col.field == isProcessStepPrinter || col.field == isProductType || col.field == isBuffer ">
                    {{rowData[col.field]!= null? rowData[col.field].name :''}}
                </td>
                <td *ngIf="col.field==isSalesItemType">
                    <div *ngFor="let sit of rowData[col.field]">
                        {{sit.sitKey}}
                    </div>
                </td>
                <td *ngIf="col.field == isDefaultTemplate">
                    {{rowData[col.field]!= null? rowData[col.field].templateName :''}}
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary" let-rowData>
        <div style="text-align:left">
            <button type="button" class="h-2rem" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
        </div>
    </ng-template>
</p-table>

<p-dialog header="{{popupTitle}} Details" position="top" position="top" [(visible)]="displayMasterListDialog"  showEffect="fade"
    [modal]="true" [style]="{'width':'800px'}" [baseZIndex]="1000">
    <div *ngIf="masterList">
        <div *ngFor="let col of tableCols">
            <div class="form-group m-2">
                <div *ngIf="col.field!=isDefaultLanguage">
                    <label>{{col.header}}</label>
                </div>
                <div
                    *ngIf="col.field!=isActive && col.field != isDefault  && col.field != isPremixed && col.field != 'printEnabled' && col.field != 'defaultPrinter' && col.field!=isLab && col.field!=isBA
                && col.field!=isDefaultLanguage && col.field != isCountry && col.field != isProductType && masterListType != seqConfigType && col.field != isHazardousType
                && col.field != isOriginalVolume && col.field != isRemainingVolume &&masterListType != machineType  && col.field != isWorkflow && col.field != isSnpProfile
                && col.field != isBmsKitProductName && col.field != isBmsTubeProductName && col.field != isProcessStepPrinter && col.field !=isProcessStepMachineType && masterListType != processStep
                && masterListType != echoConfigType && col.field != isCategory && col.field !=isJobTime && col.field != isBuffer && col.field != isSequencer &&
                col.field != isAssayType && col.field!=isSalesItemType && col.field!=isHostAddress && col.field!='ipAddress' && col.field!= isDefaultTemplate &&  col.field != 'dateFormat' && col.field != 'dateTimeFormat'&& col.field != 'workfileNameFormat'&&
                col.field!=isMaxRedo && col.field!=isReactionOptionProtocol && col.field != isLiquidHandling && col.field != isMeasurements && col.field != isScanner && col.field != 'subType' && col.field != isNumberOfPC && col.field != isNumberOfNC && col.field != isFileType && col.field != isIOCapacity && col.field != isManufacturer
                &&  col.field != isFlaTestProcess && col.field != isUnboxingInBatches && col.field != haveClippingMachine && col.field != isReducedConfirmationTests && col.field != isReportingOutsideBB && col.field != isNumberOfPositivePCRControls && col.field != isNumberOfNegativePCRControls && col.field != tagSystem && col.field!=isrequiredRead" >

                    <input pInputText class="form-control" [ngClass]=" { 'disableTextBox' : isLabValid(col.field) }"
                        [(ngModel)]="masterList[col.field]"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                <div
                    *ngIf="col.field!=isActive && col.field!=isLab && col.field != isMachineType && masterListType == machineType && col.field !=isSalesItemType && col.field!=isHostAddress && col.field != 'ipAddress' && col.field != 'subType' && col.field != isFileType && col.field != isIOCapacity && col.field != isManufacturer">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                <div *ngIf="col.field == isActive || col.field == isDefault || col.field == isPremixed || col.field == isSequencer ||
                    col.field == isLiquidHandling || col.field == isMeasurements || col.field == isScanner || col.field == isFlaTestProcess || col.field == isUnboxingInBatches || col.field == haveClippingMachine || col.field == isReducedConfirmationTests || col.field == isReportingOutsideBB" >
                    <p-checkbox id="active" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
                </div>
                <div *ngIf="col.field == 'printEnabled'">
                    <p-checkbox id="printEnabled" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
                </div>
                <div *ngIf="col.field == 'defaultPrinter'">
                    <p-checkbox id="defaultPrinter" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
                </div>
                <div
                    *ngIf="col.field == isLab && masterListType!= product && masterListType!= printer && masterListType!= machineType">
                    <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true"
                      filterBy="label" placeholder="Select a Lab" optionLabel="name" [showClear]="true"></p-dropdown>
                </div>
                <div id="selectLabForProduct"
                    *ngIf="col.field == isLab && (masterListType == product || masterListType== printer || masterListType== machineType)">
                    <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true"
                     filterBy="label"
                        placeholder="Select a Lab" optionLabel="name" [showClear]="true"
                        (onChange)="onLabSelect($event.value)"></p-dropdown>
                </div>
                <div *ngIf="col.field == 'tagSystem'">
                    <p-dropdown [options]="tagSystemOptions" [(ngModel)]="selectedTagSystem" optionLabel="tagSystemName"
                      placeholder="Select a Tag System"  [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isrequiredRead">
                    <input pInputText type="number" class="form-control" [(ngModel)]="masterList[col.field]"
                    oninput="this.value = this.value.replace(/[^0-9]/, '')"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                <div *ngIf="col.field == isBA">
                    <p-dropdown [options]="baOptions" [(ngModel)]="selectedBA" filter="true" filterBy="label" placeholder="Select a BA"
                        [style]="{'width':'230px'}" optionLabel="name" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isCountry">
                    <p-dropdown [options]="countries" [(ngModel)]="selectedCountryCode" filter="true"
                    optionLabel="label" optionValue="value" filterBy="label" [style]="{'width':'230px'}" placeholder="Select a Country" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == 'dateFormat'">
                    <p-dropdown [options]="dateOptions" [(ngModel)]="selectedDateFormat" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" [style]="{'width':'230px'}" placeholder="Select a Date Time Format" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == 'dateTimeFormat'">
                    <p-dropdown [options]="dateTimeFormatOptions" [(ngModel)]="selectedDateTimeFormat" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" [style]="{'width':'230px'}" placeholder="Select a Time Zone" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == 'workfileNameFormat'">
                    <p-dropdown [options]="workfileDateTimeFormatOptions" [(ngModel)]="selectedWorkfileFormat" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" [style]="{'width':'230px'}" placeholder="Select a file-DateTime Format" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isProductType">
                    <p-dropdown [options]="productOptions" [(ngModel)]="selectedProdType" filter="true" filterBy="label"
                        [style]="{'width':'230px'}" optionLabel="name" placeholder="Select a Product Type"
                        [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isWellType">
                    <p-dropdown [options]="wellTypes" [(ngModel)]="selectedWellType" filter="true" optionLabel="label"
                     filterBy="label"
                        [style]="{'width':'230px'}" optionLabel="label" placeholder="Select a Well Type"
                        [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isCategory">
                    <p-dropdown [options]="categories" [(ngModel)]="selectedCategory" filter="true"  filterBy="label"
                        [style]="{'width':'350px'}" optionLabel="label" placeholder="Select a Category"
                        [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isHazardousType">
                    <p-dropdown [options]="hazardousTypeOptions" [(ngModel)]="selectedHazardoustype"
                        [style]="{'width':'350px'}" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" placeholder="Select a Hazaradous Type"
                        optionLabel="label" [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field==isMachineType && masterListType==machineType">
                    <p-dropdown [options]="machineTypesOptions" [(ngModel)]="selectedMachineType" filter="true" filterBy="label"
                        placeholder="Select a Machine Type" [style]="{'width':'200px'}" optionLabel="name"
                        [showClear]="true">
                    </p-dropdown>
                </div>

                <div *ngIf="col.field == isOriginalVolume || col.field == isRemainingVolume">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" maxlength="14"
                        oninput="this.value = this.value.replace(/[^0-9]/, '')"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                <div
                    *ngIf="masterListType == seqConfigType && col.field != isPlateSealing && col.field != isLab && col.field != isProductType && col.field != isActive && col.field != isOriginalVolume && col.field != isRemainingVolume && col.field != isWellType">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" maxlength="20"
                        oninput="this.value = this.value.replace(/[^A-Za-z0-9(){}_+-]/, '')"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>

                <div *ngIf="masterListType == seqConfigType && col.field == isPlateSealing">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" maxlength="20"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>

                <div *ngIf="col.field == isJobTime">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
                        (change)="changeJobTimeForProduct()">
                </div>

                <div *ngIf="col.field == isSalesItemType">
                    <p-multiSelect [options]="sitConfigOptions" [(ngModel)]="selectedSitConfigArray" filter="true"  filterBy="label"
                        [style]="{'width':'300px'}" optionLabel="sitKey" defaultLabel="Select a Sales Item Type">
                    </p-multiSelect>
                </div>

                <div *ngIf="col.field == isBmsKitProductName">
                    <p-dropdown [options]="bmsProductNames" [(ngModel)]="selectedBmsKitProductName" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label"
                        [style]="{'width':'100%'}" optionLabel="name" placeholder="Select a BMS Kit Product name"
                        [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isBmsTubeProductName">
                    <p-dropdown [options]="bmsProductNames" [(ngModel)]="selectedBmsTubeProductName" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label"
                        [style]="{'width':'100%'}" optionLabel="name" placeholder="Select a BMS Tube Product Name"
                        [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isWorkflow">
                    <p-dropdown [options]="workFlowOptions" [(ngModel)]="selectedWorkflowType" filter="true" filterBy="label"
                    [style]="{'width':'230px'}" optionLabel="workFlowName" placeholder="Select a Workflow Type"
                    [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isSnpProfile">
                    <p-dropdown [options]="snpProfileOptions" [(ngModel)]="selectedSnpProfile" filter="true" filterBy="label"
                    [style]="{'width':'230px'}" optionLabel="snpProfileName" placeholder="Select a SNPProfile Name"
                    [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isProcessStepPrinter">
                    <p-dropdown [options]="printerOptions" [(ngModel)]="selectedPrinter" filter="true"  filterBy="label"
                        [style]="{'width':'230px'}" optionLabel="name" placeholder="Select a printer"
                        [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isProcessStepName && masterListType == processStep">
                    <p-dropdown [options]="processStepOptions" [(ngModel)]="selectedProcessStep" filter="true"filterBy="label"
                        [style]="{'width':'230px'}" optionLabel="label" placeholder="Select a process step"
                        [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isBuffer">
                    <p-dropdown [options]="bufferChemicalOptions" optionLabel="name"
                        [(ngModel)]="selectedBufferChemical" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" [style]="{'width':'230px'}"
                        placeholder="Select a Buffer" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isAssayType">
                    <p-dropdown [options]="assayTypeOptions" [(ngModel)]="selectedAssayType"
                        filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" [style]="{'width':'230px'}" placeholder="Select an AssayType"
                        [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isJobTime" class="ui-dialog-buttonpane ui-helper-clearfix">
                    <button type="button" pButton icon="pi pi-check" class="h-2rem" (click)="runJobForProduct()"
                        label="Create Order"></button>
                </div>

                <div *ngIf="col.field==isHostAddress">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
                        (keyup)="ipNameEnforce($event)" (focus)="ipNameEnforce($event)">
                    <div [(hidden)]="isNotIpAddress" style="color:red">{{warningText}}</div>
                </div>

                <div *ngIf="col.field=='ipAddress'">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]">
                    <div [(hidden)]="isNotIpAddress" style="color:red">{{warningText}}</div>
                </div>

                <div *ngIf="col.field == isDefaultTemplate">
                    <p-dropdown [options]="labelTemplateOptions" [(ngModel)]="selectedTemplate" filter="true"
                     filterBy="label"
                        [style]="{'width':'230px'}" optionLabel="templateName" placeholder="Select a Template"
                        [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isMaxRedo">
                    <p-dropdown [options]="maxRedoValues" [(ngModel)]="selectedMaxRedo" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label"
                        [style]="{'width':'230px'}" [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isReactionOptionProtocol">
                    <p-dropdown [options]="reactionOptionValues" [(ngModel)]="reactionOption"
                        [style]=" {'width':'230px'}" [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == 'subType'">
                    <input pInputText class="form-control" [ngClass]=" { 'disableTextBox' : isLabValid(col.field) }"
                        [(ngModel)]="masterList[col.field]" (change)="setSubType()">
                </div>

                <div *ngIf="col.field == isFileType">
                    <p-dropdown [options]="machineFileTypeOptions" [(ngModel)]="selectedMachineFileType"
                        placeholder="Select a File Type" [style]="{'width':'230px'}"
                        [showClear]="true">
                    </p-dropdown>
                </div>

                <div *ngIf="col.field == isIOCapacity">
                    <p-dropdown [options]="ioCapacityOptions" [(ngModel)]="ioCapacity"
                        placeholder="Select a IO Capacity" [style]="{'width':'230px'}"
                        [showClear]="true">
                    </p-dropdown>
                </div>

                <div *ngIf="col.field == isManufacturer">
                    <p-dropdown [options]="machineManufacturerOptions" [(ngModel)]="selectedMachineManufacturer"
                        placeholder="Select a Manufacturer" [style]="{'width':'230px'}"
                        [showClear]="true">
                    </p-dropdown>
                </div>

                <div *ngIf="col.field == isNumberOfPC || col.field == isNumberOfPositivePCRControls">
                    <p-inputNumber [showButtons]="true" name="barcodeQuantity" size="3" [(ngModel)]="masterList[col.field]" [min]="0" [max]="3"
                      required="true" placeholder="0"></p-inputNumber>
                  </div>
                  <div *ngIf="col.field == isNumberOfNC || col.field == isNumberOfNegativePCRControls">
                    <p-inputNumber [showButtons]="true" name="barcodeQuantity" size="3" [(ngModel)]="masterList[col.field]" [min]="0" [max]="3"
                      required="true" placeholder="0"></p-inputNumber>
                  </div>

            </div>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button type="button" class="h-2rem" pButton icon="pi pi-check" [disabled]="isSaveDisabled()"  (click)="saveMasterList()"
                label="Save"></button>
        </div>
    </p-footer>
</p-dialog>

<p-dialog header="Delete" [(visible)]="displayDeleteDialog" modal="modal" [style]="{'width':'350px'}"
    [minY]="70" [baseZIndex]="1000">
    <strong>Do you really want to delete this Item?</strong>
    <p-footer>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="deleteMasterList()"></button>
        <button type="button" pButton icon="pi pi-times" (click)="displayDeleteDialog=false" label="No"></button>
    </p-footer>
</p-dialog>

<div class="message-service-wrapper">
    <p-toast position="top-right"></p-toast>
</div>
